var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "transcript-summary-item",
      class: { "transcript-summary-item--inverted": _vm.inverted }
    },
    [
      _vm.icon
        ? _c("icon-svg", {
            staticClass: "mr-2 flex-shrink-0",
            attrs: { name: _vm.icon, size: _vm.iconSize, color: _vm.iconColor }
          })
        : _vm._e(),
      _c(
        "span",
        { staticClass: "az-text-primary az-size-12" },
        [_vm._v(" " + _vm._s(_vm.text)), _vm._t("default")],
        2
      ),
      _vm.$slots.right
        ? _c(
            "div",
            { staticClass: "ml-auto pl-3 flex-shrink-0 d-flex align-center" },
            [_vm._t("right")],
            2
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }